module.exports = __webpack_public_path__ + "static/media/battles-info-screen-1.3d03f6ba.png";